<template>
  <div>
    <mdb-parallax
      src="https://mdbootstrap.com/img/Photos/Others/images/76.jpg"
      height="full"
      factor="2"
    >
      <mdb-mask overlay="blue-slight" :flexCenter="windowHeight > 800">
        <mdb-row class="mb-5 pb-5 text-center white-text">
          <mdb-col md="12" xl="12" class="mx-auto">
            <div :style="'height:' + (windowHeight > 800 ? '0' : '200') + 'px; width:100%'"></div>
            <h1 class="display-3 font-weight-bold animated fadeInDown">
              Gamification
              <br />
              <a class="indigo-text">
                Pour la
                <br />Santé
              </a>
            </h1>
            <h5
              class="font-weight-bold pt-md-5 pt-sm-2 pt-5 pb-md-5 pb-sm-3 pb-5 animated fadeInDown"
            >Unity and Web development</h5>
            <!--
            <mdb-btn size="lg animated fadeInDown" color="light-blue" @click="scrollToId('team')">Equipe</mdb-btn>
            <mdb-btn size="lg animated fadeInDown" color="indigo" @click="scrollToId('contact')">Contact</mdb-btn>
            -->
          </mdb-col>
        </mdb-row>
      </mdb-mask>
    </mdb-parallax>
    <main>
      <Advantages />
      <mdb-container>
        <mdb-mask class="gradient d-flex justify-content-center align-items-center">
          <mdb-container>
            <mdb-row>
              <mdb-col xl="6" class="text-center text-md-left animated fadeInLeft">
                <h5 class="h5-responsive font-weight-bold mt-sm-5">Notre ShowReal</h5>
                <hr class="hr-light" />
                <h6
                  class="mb-4"
                >Nous avons une expérience diversifiée, incluant des projets pour des musées ou d'autres projets divers. N'hésitez pas à nous demander si votre projet est dans nos cordes, vous serez surpis !</h6>
              </mdb-col>
              <mdb-col xl="6" class="mt-xl-5 animated fadeInRight">
                <iframe
                  :width="windowWidth > 560 * 1/0.8 ? 560 : windowWidth*0.8"
                  :height="windowWidth > 560 * 1/0.8 ? 560 / videoRatio : windowWidth*0.8 / videoRatio"
                  src="https://www.youtube.com/embed/gTSGMyVdoIE"
                  frameborder="0"
                  controls="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-mask>
      </mdb-container>
    </main>
    <br />
    <br />
    <mdb-parallax
      src="https://mdbootstrap.com/img/Photos/Slides/img%20(135).jpg"
      height="full"
      factor="1"
    >
      <mdb-mask overlay="blue-slight" :flexCenter="windowWidth > 900">
        <mdb-row class="mb-5 pb-5 text-center white-text">
          <mdb-col md="12" xl="12" class="mx-auto">
            <h1 class="display-3 font-weight-bold animated fadeInDown">Ils nous font confiance</h1>
          </mdb-col>
          <div class="auto-margin">
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/bbw_small.png" />
            </div>
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/Toptal-Rackpost_small.png" />
            </div>
            <div>
              <img
                class="client-image z-depth-3"
                src="../assets/Clients/logo-cite-des-sciences_small.png"
              />
            </div>
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/youmeal.png" />
            </div>
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/Fresnoy.png" />
            </div>
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/moveup.jpeg" />
            </div>
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/Musee-de-la-ville.png" />
            </div>
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/tinyBigStory.png" />
            </div>
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/kascen.png" />
            </div>
            <div>
              <img class="client-image z-depth-3" src="../assets/Clients/Trigrr.png" />
            </div>
          </div>
        </mdb-row>
      </mdb-mask>
    </mdb-parallax>
    <main>
      <mdb-container>
        <section class="text-center my-5">
          <h2 class="h1-responsive font-weight-bold my-5">Toujours pas convaincu?</h2>
          <p
            class="dark-grey-text w-responsive mx-auto mb-5"
          >Nous souhaitons allier efficacité et bien-être relationnel, et nous avons toujours beaucoup de plaisir à travailler avec des client aussi formidables.</p>
          <mdb-row>
            <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
              <mdb-card testimonial>
                <mdb-card-up color="info"></mdb-card-up>
                <mdb-avatar class="mx-auto white">
                  <a href="https://www.linkedin.com/in/maximevandievoet/" target="_blank">
                    <img src="../assets/Testimonials/max.jpg" alt class="rounded-circle img-fluid" />
                  </a>
                </mdb-avatar>
                <mdb-card-body>
                  <h4 class="font-weight-bold mb-4">Maxime Van Dievoet</h4>Digital Project Manager at BIG BAD WOLF
                  <hr />
                  <p class="dark-grey-text mt-4">
                    <i class="fas fa-quote-left pr-2"></i>Baptiste was a blessing for the projects we were working on. Professionally, he was more than competent thanks to the quality of his education
                    and his curiosity. I confirm his mastery of Unity as well as his qualities as a developer on the various 3D projects we entrusted him with. He is proactive,
                    problem solver and his mind is well structured. On a personal level, Baptiste has integrated perfectly into our company and has a very pleasant
                    personality.
                    <br />I recommend that you hire him before we can convince him to come back to work for us.
                  </p>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
            <mdb-col lg="4" md="6" class="mb-lg-0 mb-4">
              <mdb-card testimonial>
                <mdb-card-up gradient="blue"></mdb-card-up>
                <mdb-avatar class="mx-auto white">
                  <a href="http://www.tinybigstory.be/" target="_blank">
                    <img
                      src="../assets/Testimonials/xavierwielemans.jpg"
                      class="rounded-circle img-fluid"
                      alt
                    />
                  </a>
                </mdb-avatar>
                <mdb-card-body>
                  <h4 class="font-weight-bold mb-4">Xavier Wielemans</h4>Freelance Multimedia Developer
                  <hr />
                  <p class="dark-grey-text mt-4">
                    <i class="fas fa-quote-left pr-2"></i>Baptiste helped me out on a complex data visualization project involving several challenges: real-time, web-based, mixed 2D/3D, dynamic data mining,.. He jumped into the project with as much enthusiasm as creativity, throwing many interesting ideas back at me all along the process. Eventually he finalized the part of the project I had allocated him in a totally autonomous fashion, up to deploying it at the final customer site in Paris, France. His reliability, care for detail and sense of finish make that I have often recommended him around since then.
                  </p>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
            <mdb-col lg="4" md="6" class="mb-lg-0 mb-4">
              <mdb-card testimonial>
                <mdb-card-up class="indigo"></mdb-card-up>
                <mdb-avatar class="mx-auto white">
                  <a href="https://mlg.info.ucl.ac.be/Members/JohnLee" target="_blank">
                    <img src="../assets/Testimonials/johnlee.jpg" class="rounded-circle img-fluid" />
                  </a>
                </mdb-avatar>
                <mdb-card-body>
                  <h4 class="font-weight-bold mb-4">John Lee</h4>Professor and master of research in FNRS
                  <hr />
                  <p class="dark-grey-text mt-4">
                    <mdb-icon icon="quote-left" class="pr-2"></mdb-icon>I strongly recommend Baptiste Degryse, with no
                    reservation whatsoever, and I am sure he will make good use of his creativity, sense of initiative,
                    and numerous, cross-disciplinary skills.
                  </p>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
          </mdb-row>
        </section>
      </mdb-container>
      <mdb-container>
        <section class="text-center">
          <h2 class="font-weight-bold my-5" id="team">Team</h2>
          <p class="grey-text w-responsive mx-auto mb-5">Deux expertises: Technologie et santé.</p>
          <mdb-row>
            <mdb-col md="6" class="mb-lg-0 mb-5">
              <mdb-avatar class="mx-auto white">
                <a href="https://www.linkedin.com/in/baptiste-degryse-033299114/" target="_blank">
                  <img src="../assets/baps.png" class="rounded-circle img-fluid hoverable" />
                </a>
              </mdb-avatar>

              <h5 class="font-weight-bold mt-4 mb-3">Baptiste Degryse</h5>
              <p class="text-uppercase blue-text">Développeur Unity et Fullstack Web</p>
              <p class="grey-text">
                Ingénieur civil en intelligence artificielle, Baptiste a lancé DBloke en 2018 pour aider à faire avancer le monde dans la bonne direction.
                En travaillant sur des expositions pour des musées, en consultance web ou dans des projets personnels, il a élargi son expertise technique afin de pouvoir répondre à tous les besoins.
                Il a été ravi d'accueillir Jérôme en tant qu'associé quelques années plus tard, afin de lier la santé à son activité.
              </p>
              <mdb-btn
                tag="a"
                floating
                size="sm"
                class="mx-1 mb-0 btn-email"
                href="mailto:baptiste@dbloke.be"
              >
                <mdb-icon icon="envelope" />
              </mdb-btn>
              <mdb-btn
                tag="a"
                floating
                size="sm"
                class="mx-1 mb-0 btn-fb"
                href="https://www.linkedin.com/in/baptiste-degryse-033299114/"
                target="_blank"
              >
                <mdb-icon fab icon="linkedin" />
              </mdb-btn>
            </mdb-col>
            <mdb-col md="6" class="mb-lg-0 mb-5">
              <mdb-avatar class="mx-auto white">
                <a
                  href="https://www.linkedin.com/in/j%C3%A9r%C3%B4me-dewandre-1634971a1/"
                  target="_blank"
                >
                  <img src="../assets/jer.jpg" class="rounded-circle img-fluid hoverable" />
                </a>
              </mdb-avatar>
              <h5 class="font-weight-bold mt-4 mb-3">Jérome Dewandre</h5>
              <p class="text-uppercase blue-text">Project Manager</p>
              <p
                class="grey-text"
              >Ingénieur civil et kinésithérapeute, Jérôme a rejoint Baptiste en 2020 chez Dbloke. Son expertise couvre l'analyse de données, l'intelligence artificielle, le développement web et le développement de "medical devices" grâce à ses connaissances dans le domaine médical. Il pourra vous fournir, en combinant la technique et ses connaissances dans le domaine de la santé, un support au plus proche de vos attentes.</p>

              <mdb-btn
                tag="a"
                floating
                size="sm"
                class="mx-1 mb-0 btn-email"
                href="mailto:dewandre.jerome@dbloke.be"
              >
                <mdb-icon icon="envelope" />
              </mdb-btn>
              <mdb-btn
                tag="a"
                floating
                size="sm"
                class="mx-1 mb-0 btn-fb"
                href="https://www.linkedin.com/in/j%C3%A9r%C3%B4me-dewandre-1634971a1/"
                target="_blank"
              >
                <mdb-icon fab icon="linkedin" />
              </mdb-btn>
            </mdb-col>
          </mdb-row>
        </section>
      </mdb-container>
       <hr />
      <mdb-container>
        <!--Grid row-->
        <mdb-row class="py-5">
          <!--Grid column-->
          <mdb-col md="12" class="text-center">
            <h2 class="font-weight-bold">Notre expertise</h2>
            <p>Nos profils combinés nous permettent de faire toutes sortes d'applications interactives. 
              Nous pouvons créer des applications pour tous les systèmes d'exploitation (Mac, Windows, Linux), en réalité augmentée (Android, iOS) ou en réalité virtuelle (Occulus, Vive).
              Nous sommes aussi compétents en développement web, pour des sites vitrines ou pour les progressives web app (site web similaire à une application standard, téléchargeable et qui fonctionne sans connection internet).
              Si vous désirez une application native (seulement pour smartphone, mais bien optimisée pour ceux-ci), nous serons ravi de publier votre application sur google play et/ou apple store.
              Grâce notre formation, nous pouvons également gérer tout ce qui touche au médical (application interactive pour la collecte de données, nutrition, ...) et à la data science.
              Nous espérons pouvoir vous fournir, en combinant la technique et nos connaissances dans le domaine médical, un support au plus proche de vos attentes.
              </p>
              </mdb-col>
          <!--Grid column-->
        </mdb-row>
        <!--Grid row-->
      </mdb-container>
      <hr />
      <mdb-container>
        <!--Grid row-->
        <mdb-row class="py-5">
          <!--Grid column-->
          <mdb-col md="12" class="text-center">
            <h2 class="font-weight-bold">Nos Valeurs</h2>
            <h5>Intégrité</h5>
            <p>Nous ne souhaitons pas vendre nos valeurs. 
              Nous voulons laisser une empreinte neutre ou positive sur notre planette adorée. 
              La première étape de cette démarche consiste à faire tous nos trajets à vélo ou en transport en commun, et à n'accepter que des projets éthiques.
              Tout le monde a un impact sur notre société, et nous allons tirer dans une direction qui a du sens pour nous.
              </p>
            <h5>Transparence</h5>
            <p> La plupart des conflits humains peuvent être évités grâce à une bonne transparence et une communication non-violente. 
              Nous croyons fermement qu'il est possible de vivre une carrière dans un esprit de respect familial, tout en se faisant respecter pour la qualité de notre travail.
              Toutes les parties profitent d'une bonne communication ouverte et sereine.
            </p>
            <h5>Fiabilité et perfectionnisme</h5>
            <p>
              Bien sûr, nous mettons un point d'honneur à être fiable et à atteindre vos attentes. Un bon project manager a trois exigences: gérer un projet dans les temps, gérer le budget, et remplir le cahier des charges.
              Nous souhaitons en ajouter une quatrième: atteindre les attentes du client car rien n'est plus satisfaisant dans la vie que de bien faire son travail, et qu'il soit apprécié par tous.
            </p>
          </mdb-col>
          <!--Grid column-->
        </mdb-row>
        <!--Grid row-->
      </mdb-container>
      <mdb-container>
        <section class="contact-section my-5" id="contact">
          <mdb-card>
            <mdb-row>
              <mdb-col lg="8">
                <mdb-card-body class="form">
                  <h3 class="mt-4">
                    <mdb-icon icon="envelope" class="pr-2" />Contact:
                  </h3>
                  <mdb-row>
                    <mdb-col md="6">
                      <div class="md-form mb-0">
                        <mdb-input type="text" id="form-contact-name" label="Nom" v-model="name" />
                      </div>
                    </mdb-col>
                    <mdb-col md="6">
                      <div class="md-form mb-0">
                        <mdb-input
                          type="text"
                          id="form-contact-email"
                          label="Email"
                          v-model="email"
                        />
                      </div>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col md="6">
                      <div class="md-form mb-0">
                        <mdb-input
                          type="text"
                          id="form-contact-phone"
                          label="Téléphone"
                          v-model="phone"
                        />
                      </div>
                    </mdb-col>
                    <mdb-col md="6">
                      <div class="md-form mb-0">
                        <mdb-input
                          type="text"
                          id="form-contact-company"
                          label="Société"
                          v-model="company"
                        />
                      </div>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col md="10">
                      <div class="md-form mb-0">
                        <mdb-textarea
                          id="form-contact-message"
                          label="Message"
                          rows="5"
                          v-model="message"
                        />
                      </div>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col md="12">
                      <mdb-btn tag="a" floating color="blue" size="lg" @click="sendMessage()">
                        <mdb-icon far icon="paper-plane" />
                      </mdb-btn>
                    </mdb-col>
                  </mdb-row>
                </mdb-card-body>
              </mdb-col>
              <mdb-col lg="4">
                <mdb-card-body class="contact text-center h-100 white-text">
                  <h3 class="my-4 pb-2">Nos informations</h3>
                  <ul class="text-lg-left list-unstyled ml-4">
                    <li>
                      <p>
                        <mdb-icon icon="map-marker" class="pr-2" />1420, Braine-l'Alleud
                      </p>
                    </li>
                    <li>
                      <p>
                        <mdb-icon icon="phone" class="pr-2" />+32 470 52 59 55
                      </p>
                    </li>
                    <li>
                      <p>
                        <mdb-icon icon="envelope" class="pr-2" />info@dbloke.be
                      </p>
                    </li>
                  </ul>
                  <hr class="hr-light my-4" />
                  <ul class="text-lg-left list-unstyled ml-4">
                    <li>
                      <p>
                        <mdb-icon icon="user-tie" class="pr-2" />TVA: BE 0694.596.511
                      </p>
                    </li>
                  </ul>
                </mdb-card-body>
              </mdb-col>
            </mdb-row>
          </mdb-card>
        </section>
      </mdb-container>
    </main>
  </div>
</template>

<script>
import Advantages from "@/components/Advantages.vue";
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbInput,
  mdbTextarea,
  mdbContainer,
  mdbParallax,
  mdbMask,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbView,
  mdbCard,
  mdbCardBody,
  mdbCardUp,
  mdbAvatar,
  mdbIcon,
} from "mdbvue";
import db from "../main.js";

export default {
  name: "Home",
  components: {
    Advantages,
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbInput,
    mdbTextarea,
    mdbContainer,
    mdbParallax,
    mdbMask,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbView,
    mdbCard,
    mdbCardBody,
    mdbCardUp,
    mdbAvatar,
    mdbIcon,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      videoRatio: 560 / 315,
      name: "",
      phone: "",
      email: "",
      company: "",
      message: "",
      mailDocument: false,
    };
  },
  methods: {
    async sendMessage() {
      if(!this.message){
       this.$notify.warn({
          message: "Vous n'avez rien écrit :/",
          position: "bottom center",
          timeOut: 5000,
        });
        return;
      }
      try {
        this.mailDocument = await db.collection("mail").add({
          to: ["baptiste@dbloke.be", "jerome.dewandre@dbloke.be"],
          reply: this.email,
          message: {
            subject: "Website contact from " + this.name,
            text:
              this.message +
              " \n\nName: " +
              this.name +
              "\nPhone: " +
              this.phone +
              "\nEmail: " +
              this.email +
              "\nCompany: " +
              this.company,
          },
        });
        this.$notify.success({
          message: "Message envoyé !",
          position: "bottom center",
          timeOut: 5000,
        });
        this.message = "";
      } catch (e) {
        this.$notify.error({
          message: "Une erreur est survenue, envoyez-nous un email standard",
          position: "bottom center",
          timeOut: 5000,
        });
      }
    },
    scrollToId: function (id) {
      let top = 0;
      if(id) top = document.getElementById(id).offsetTop - 100;
      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    });
  },
};
</script>
<style lang="scss">
h1,
h5 {
  text-transform: uppercase;
}

h5 {
  letter-spacing: 3px;
}
@media (max-width: 767.98px) {
  h1 {
    font-size: 2.5em !important;
  }
  h5 {
    font-size: 1.5em !important;
  }
}
.auto-margin {
  width: 90%;
  margin: auto;
  overflow-y: auto;
  height: 100%;
  div {
    padding: 3px;
    background: white;
    display: inline-block;
    margin: 20px;
    max-width: 100%;
    .client-image {
      display: inline-block;
      height: 100px;
      width: auto;
      max-width: 100%;
    }
  }
}
</style>